import tableModule from './modules/table';

const state = {
  ...tableModule.state,
  currentTableCity: null,
};

const getters = {
  ...tableModule.getters,
};

const actions = {
  ...tableModule.actions,

  setCurrentTableCity(context, value) {
    context.commit('SET_CURRENT_TABLE_CITY', value);
  },
};

const mutations = {
  ...tableModule.mutations,
  SET_CURRENT_TABLE_CITY(state, value) {
    state.currentTableCity = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
